import {useContext, useEffect} from 'react'
import {AppContext} from '../contexts/AppContext'
import useApi from './useApi';
import { PackageSelectorContext } from 'contexts/PackageSelectorContext';
import { participationsLookup } from 'main/specificUtils/configs';

const participationNames = {
  [participationsLookup.INPSIEME]: 'INPS',
  [participationsLookup.INPSNUOVO]: 'INPSN',
  [participationsLookup.PRIVATO]: 'PVT',
  [participationsLookup.AZIENDA_CONVENZIONATA]: 'AZ'
}

export default function useBundles() {
  const [state, setState] = useContext(AppContext)
  const api = useApi()
  const [psState] = useContext(PackageSelectorContext)

  function onSelectBundle(bundleId, bundleIdToRemove) {
    const {
      step4Bundles: selectedBundles
    } = state

    let bundles = [...selectedBundles]

    if(bundles.includes(bundleId)) {
      bundles = bundles.filter(el => el !== bundleId)
    } else {
      bundles = bundles.concat(bundleId)
    }

    if(bundleIdToRemove !== undefined) {
      bundles = bundles.filter(el => el !== bundleIdToRemove)
    }

    setState(state => ({...state, step4Bundles: bundles}))
  }

  async function getBundles() {
    try {
      setState(state => ({
        ...state,
        fetchingBundles: true,
      }))
      const bundles = await api.getBundlesByPackageId(
        psState.package, 
        participationNames[state.step2Participation]
      )
      setState(state => ({
        ...state,
        bundles,
        fetchingBundles: false,
      }))
    } catch(error) {
      console.error(
        `Error getting bundles for package ${psState.package}`,
        error
      )
    }
  }

  useEffect(() => {
    getBundles();
  }, [])

  return {
    onSelectBundle,
  }
}
